import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import React from "react";
import FormatBandwidth from "./FormatBandwidth";
import LogEmptyState from "./LogEmptyState";
import LogLoadingRow from "./LogLoadingRow";
import { FormatDateAndTime } from "./FormatDate";

interface SocksLog {
  createdAt: number;
  requestedAt: number;
  requestContentLength: number;
  responseContentLength: number;
  requestUrl: string;
}

interface SocksLogTableProps {
  logs: SocksLog[];
  isFirstPage: boolean;
  isLoading: boolean;
  rpp: number;
}

export default (props: SocksLogTableProps) => (
  <TableContainer>
    <Table sx={{ minWidth: 600 }}>
      <colgroup>
        <col style={{ width: '40%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '20%' }} />
      </colgroup>
      <TableHead>
        <TableRow>
          <TableCell>Remote Host</TableCell>
          <TableCell>Date</TableCell>
          <TableCell>Request Bandwidth</TableCell>
          <TableCell>Response Bandwidth</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.logs.map((row) => (
          < TableRow
            key={row.createdAt}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {row.requestUrl}
            </TableCell>
            <TableCell>
              <FormatDateAndTime epoch={row.requestedAt} />
            </TableCell>
            <TableCell>
              <FormatBandwidth bytes={row.requestContentLength} />
            </TableCell>
            <TableCell>
              <FormatBandwidth bytes={row.responseContentLength} />
            </TableCell>
          </TableRow>
        ))}
        {props.isLoading && (
          [...Array(props.rpp).keys()].map((i) => (
            <LogLoadingRow key={i} columns={4} />
          ))
        )}
      </TableBody>
    </Table>
    {props.isFirstPage && props.logs.length === 0 && !props.isLoading && <LogEmptyState />}
  </TableContainer >
)
